export default "__VITE_ASSET__DWH1KBh1__"